// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2GBlm","additionalInfo":"AgreementModal_additionalInfo__3i9BS"};